var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchtool-sentence"},[_c('div',{staticClass:"searchtool-sentence__headline"},[_vm._v(" Content Finder ")]),_c('h1',{staticClass:"searchtool-sentence__text h1--long",domProps:{"innerHTML":_vm._s(_vm.sentence)}})])}
var staticRenderFns = []

export { render, staticRenderFns }